module.exports = __webpack_public_path__ + "img/information_img_nor.e8fd4c30.png";